import {SelectBonusModule, SelectBonusView} from '@gongxigames/framework/slot/modules/selectBonus';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';
import {LogicEvents} from '@gongxigames/framework/slot/services/logic/LogicEvents';
import {ModuleState} from '@gongxigames/framework/slot';

export class SelectBonusPlayingState extends ModuleState<SelectBonusView, SelectBonusModule, GlobalEventsMapForBackwardCompatibility> {
    protected setupEvents(): void {
        this.setEventHandler(LogicEvents.SELECT_RESPONSE, this.onSelectResponse.bind(this));
    }

    public onEnterState(): void {
        this.view.show();
        this.emit('General.UI.DISABLE', SelectBonusModule.NAME);
    }

    public onLeaveState(): void {
        this.emit('General.UI.ENABLE', SelectBonusModule.NAME);
    }

    protected onSelectResponse(): void {
        this.view.hide();
    }
}
